export const defaultState: Fields = {
  selectedMapObjectId: undefined,
  ctxMenuMapObjectId: undefined,
  listViewWidth: 0,
};

export interface Fields {
  selectedMapObjectId?: string | null;
  mapObjectSelectionSource?: MapObjectSelectionSourceEnum;
  ctxMenuMapObjectId?: string | null;
  searchKeyword?: string;
  listViewWidth: number;
}

export enum MapObjectSelectionSourceEnum {
  List = 0,
  Map = 1,
  Details = 2,
}
